<!--
 * @Description: 最低风险提示
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-10-21 14:46:45
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div class="comp-fund-protocol comp">
        <el-dialog
            class="prop"
            :visible.sync="centerDialogVisible"
            width="1000px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            v-on:close="closed"
        >
            <div slot="title" class="title-contain">
                <img
                    v-if="$cache.getCompanyInfoParam('10101007')"
                    :src="
                        $util.imgSrc({
                            fileCode: $cache.getCompanyInfoParam('10101007')
                        })
                    "
                    height="30"
                />
                <div class="title-bar">|</div>
                <div>销售适当性风险提示及声明</div>
            </div>
            <div class="protocol-con">
                <div class="risk-condition-contain">
                    <div class="img-flex">
                        <img src="@/assets/img/warn-tip.png" class="m-r-4" />
                        <div class="protocol-title">提示</div>
                    </div>
                    <div class="protocol-content">
                        您的风险测评结果是
                        <label class="font-red">
                            {{
                                info.risklevel == "0"
                                    ? "C0(不能承受风险)"
                                    : $cache.getDict("100017", info.risklevel)
                            }}
                        </label>
                        {{
                            "，不能购买" +
                            (info.risklevel == "0" ? "任何产品" : "R1以上风险的基金") +
                            "，该基金风险等级为"
                        }}
                        <label class="font-red">
                            {{ $cache.getDict("110143", fundRisk) }}
                        </label>
                        ，已超出您的风险承受范围，无法交易。
                    </div>
                </div>
                <div class="row-bar"></div>
                <div class="risk-common-content3">
                    立即了解
                    <span v-on:click="toSdxText">《证券期货投资者适当性管理办法》</span>
                </div>
            </div>

            <div slot="footer" class="dialog-footer align-c">
                <el-button type="primary" class="close-btn" v-on:click="closed">我知道了</el-button>
                <el-button type="primary" v-on:click="confirmCon">重新测评</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Router from "@/router";

export default {
    name: "LowRiskDialog",
    data() {
        return {
            centerDialogVisible: true,
            info: {},
            fundRisk: ""
        };
    },
    mounted() {
        this.info = this.$cache.getUser();
    },
    methods: {
        toSdxText() {
            const targetPath =
                window.location.protocol + "//" + window.location.host + "/#/sdxtext";
            window.open(targetPath, "_blank");
        },
        closed() {
            this.centerDialogVisible = false;
        },
        confirmCon() {
            this.centerDialogVisible = false;
            console.log(this, this.currentRouter);
            this.currentRouter.push({ name: "risk" });
        },
        openDialog(message) {
            this.fundRisk = message;
            this.confirmDialog = true;
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";

.comp-fund-protocol {
    .title-contain {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        .title-bar {
            margin: 0 12px;
            color: #d9d9d9;
        }
    }
    .protocol-con {
        .risk-condition-contain {
            padding: 26px 0;
            .protocol-title {
                font-size: 20px;
                font-weight: bold;
                color: #333333;
            }
            .protocol-content {
                font-size: 16px;
                font-weight: normal;
                color: #333333;
                margin: 18px 0 0;
            }
        }

        .risk-common-content3 {
            margin: 14px 0 26px;
            font-size: 16px;
            font-weight: normal;
            color: #333333;
            span {
                color: #1890ff;
                cursor: pointer;
            }
        }
    }
    .dialog-footer {
        .close-btn {
            width: 180px;
            height: 42px;
            border-radius: 2px;
            background: #e4e4e4;
            border: #e4e4e4;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            color: #666666;
        }
    }
    .row-bar {
        width: 100%;
        height: 1px;
        background-color: #eeeeee;
    }
    .font-red {
        color: var(--color-primary);
    }
    .img-flex {
        display: flex;
        align-items: center;
    }
    .m-r-4 {
        margin-right: 4px;
    }
}
</style>
